import React from "react";
import banner_img from "../../assets/images/about_banner.png";
import doctor from "../../assets/icons/service_banner-01-01.svg";
import { Link } from "react-router-dom";
import { ChevronsRight } from "lucide-react";
const ServiceBanner = () => {
  return (
  <div
      className={`pt-32 pb-24 md:pb-0 relative max-sm::bg-[right_center] bg-[#f4f4f4] about-banner overflow-hidden `}
      style={{ backgroundImage: `url(${banner_img})` }}
    >
      <div className="absolute left-0 bottom-0 2xl:w-1/3 md:w-1/2 w-full">
        <img src={doctor} loading="lazy" alt="" className="" />
      </div>
      <div className="xl:w-[1280px] w-11/12 mx-auto grid grid-cols-1 md:grid-cols-2 z-10 ">
        <div className="md:block hidden">
          <img src={doctor} loading="lazy" alt="" className="p-1 invisible" />
        </div>
        <div className="flex flex-col justify-center items-center">
          <h1 className="2xl:text-8xl xl:text-7xl lg:text-6xl md:text-5xl sm:text-4xl text-4xl font-bold capitalize text-matcha">
         Specialities
          </h1>
          <p className="flex flex-row gap-1 items-center text-xl font-medium text-[#B87333]  mt-4">
            <Link to="/">Home</Link> <ChevronsRight />
            <span className="opacity-85">Specialities</span>
          </p>
        </div>
      </div>
    </div>
  );
};

export default ServiceBanner;
